import { WrenchIcon } from "@phosphor-icons/react";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { LogoMark } from "@/components/logo";

/** Shown while Kontaktfix is in maintenance mode. Returns to the app as soon as it is over. */
export function MaintenancePage() {
  const { t } = useTranslation();
  const { data } = useQuery({
    queryKey: ["maintenance"],
    queryFn: () =>
      fetch("/api/maintenance").then((r) => (r.ok ? (r.json() as Promise<{ active: boolean }>) : null)),
    refetchInterval: 30_000,
  });

  useEffect(() => {
    if (data && !data.active) window.location.assign("/");
  }, [data]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-subtle px-4 py-10">
      <div className="w-full max-w-[420px] text-center">
        <div className="flex justify-center">
          <LogoMark size={40} />
        </div>
        <h1 className="mt-5 flex items-center justify-center gap-2 text-xl font-semibold tracking-tight">
          <WrenchIcon className="size-5 text-fg-muted" />
          {t("maintenance.title")}
        </h1>
        <p className="mt-2 text-[13.5px] text-fg-muted">{t("maintenance.body")}</p>
        <p className="mt-6 text-[12px] text-fg-subtle">{t("maintenance.delivery")}</p>
      </div>
    </div>
  );
}
